<app-header />

<div class="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-4xl mx-auto">
    <!-- Profile Header -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6 no-print">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <!-- Avatar -->
          <div class="w-20 h-20 rounded-full bg-[#e8343f] flex items-center justify-center">
            <span class="text-3xl font-bold text-white">
              {{ authService.currentUser()?.firstname?.charAt(0) }}{{ authService.currentUser()?.lastname?.charAt(0) }}
            </span>
          </div>
          <!-- User Info -->
          <div>
            <h1 class="text-2xl font-bold text-gray-900">
              {{ authService.currentUser()?.firstname }} {{ authService.currentUser()?.lastname }}
            </h1>
            <p class="text-sm text-gray-600">{{ authService.currentUser()?.email }}</p>
            @if (authService.currentUser()?.role) {
              <span class="inline-block mt-1 px-3 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                {{ authService.currentUser()?.role }}
              </span>
            }
          </div>
        </div>
        <button
          (click)="logout()"
          class="px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          Cerrar Sesión
        </button>
      </div>
    </div>

    <!-- Profile Details -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6 no-print">
      <h2 class="text-lg font-semibold text-gray-900 mb-4">Información Personal</h2>
      <div class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700">Nombre</label>
            <p class="mt-1 text-sm text-gray-900">{{ authService.currentUser()?.firstname }}</p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Apellido</label>
            <p class="mt-1 text-sm text-gray-900">{{ authService.currentUser()?.lastname }}</p>
          </div>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Email</label>
          <p class="mt-1 text-sm text-gray-900">{{ authService.currentUser()?.email }}</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Usuario</label>
          <p class="mt-1 text-sm text-gray-900">{{ authService.currentUser()?.username }}</p>
        </div>
        @if (authService.currentUser()?.phone) {
          <div>
            <label class="block text-sm font-medium text-gray-700">Teléfono</label>
            <p class="mt-1 text-sm text-gray-900">{{ authService.currentUser()?.phone }}</p>
          </div>
        }
      </div>
    </div>

    <!-- Actions -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6 no-print">
      <h2 class="text-lg font-semibold text-gray-900 mb-4">Seguridad</h2>
      <div class="flex flex-col sm:flex-row gap-3">
        <a
          routerLink="/change-password"
          class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg text-white bg-[#e8343f] hover:bg-red-700 transition-colors"
        >
          Cambiar contraseña
        </a>
      </div>
    </div>

    <!-- Mis Facturas -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-lg font-semibold text-gray-900">Mis Facturas</h2>
        @if (isLoadingFacturas()) {
          <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-[#e8343f]"></div>
        }
      </div>

      @if (errorMessage()) {
        <div class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
          {{ errorMessage() }}
        </div>
      }

      @if (isLoadingFacturas()) {
        <div class="text-center py-8">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-[#e8343f] mx-auto"></div>
          <p class="mt-4 text-sm text-gray-600">Cargando facturas...</p>
        </div>
      } @else if (facturas().length === 0) {
        <div class="text-center py-8">
          <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          <h3 class="mt-2 text-sm font-medium text-gray-900">No tienes facturas</h3>
          <p class="mt-1 text-sm text-gray-500">Cuando compres tickets, tus facturas aparecerán aquí.</p>
        </div>
      } @else {
        <div class="space-y-3">
          @for (factura of facturas(); track factura.facturaid) {
            <div 
              class="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors cursor-pointer"
              (click)="viewInvoiceDetails(factura.facturaid)"
            >
              <div class="flex items-start justify-between">
                <div class="flex-1">
                  <div class="flex items-center gap-2 mb-2">
                    <h3 class="text-sm font-semibold text-gray-900">{{ factura.evento.nombre }}</h3>
                    <span [class]="'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ' + getEstadoBadgeClass(factura.estado)">
                      {{ factura.estado }}
                    </span>
                  </div>
                  <div class="space-y-1 text-sm text-gray-600">
                    <p class="flex items-center gap-1">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                      </svg>
                      Factura: #{{ factura.facturaid.substring(4, 12) }}...
                    </p>
                    <p class="flex items-center gap-1">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                      </svg>
                      Emitida: {{ formatDate(factura.fecha_emision) }}
                    </p>
                    <p class="flex items-center gap-1">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                      </svg>
                      {{ factura.evento.lugar }}
                    </p>
                  </div>
                </div>
                <div class="text-right ml-4">
                  <p class="text-lg font-bold text-[#e8343f]">${{ factura.totales.total_general_factura.toFixed(2) }}</p>
                  <p class="text-xs text-gray-500">{{ factura.items.length }} ticket(s)</p>
                  <svg class="w-5 h-5 text-gray-400 ml-auto mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<!-- Modal de Detalle de Factura -->
@if (showInvoiceDetail() && selectedFactura()) {
  <div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" (click)="closeInvoiceDetail()">
    <div id="invoice-content" class="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
      <!-- Header del Modal -->
      <div class="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
        <div>
          <h2 class="text-xl font-bold text-gray-900">Detalle de Factura</h2>
          <p class="text-sm text-gray-600">{{ selectedFactura()!.facturaid }}</p>
        </div>
        <button 
          (click)="closeInvoiceDetail()"
          class="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      @if (isLoadingDetails()) {
        <div class="p-12 text-center">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-[#e8343f] mx-auto"></div>
          <p class="mt-4 text-sm text-gray-600">Cargando detalle...</p>
        </div>
      } @else if (selectedFactura()) {
        <div class="p-6 space-y-6">
          <!-- Estado y Fecha -->
          <div class="flex items-center justify-between pb-4 border-b border-gray-200">
            <div>
              <span [class]="'inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ' + getEstadoBadgeClass(selectedFactura()!.estado)">
                {{ selectedFactura()!.estado }}
              </span>
              <p class="mt-2 text-sm text-gray-600">Emitida: {{ formatDateTime(selectedFactura()!.fecha_emision) }}</p>
            </div>
            <div class="text-right">
              <p class="text-sm text-gray-600">Total</p>
              <p class="text-3xl font-bold text-[#e8343f]">${{ selectedFactura()!.totales.total_general_factura.toFixed(2) }}</p>
            </div>
          </div>

          <!-- Información del Evento -->
          <div class="bg-gray-50 rounded-lg p-4">
            <h3 class="font-semibold text-gray-900 mb-3">Información del Evento</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <div>
                <p class="text-gray-600">Evento</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.evento.nombre }}</p>
              </div>
              <div>
                <p class="text-gray-600">Estado</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.evento.estado }}</p>
              </div>
              <div>
                <p class="text-gray-600">Lugar</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.evento.lugar }}</p>
              </div>
              <div>
                <p class="text-gray-600">URL</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.evento.url_slug }}</p>
              </div>
            </div>
          </div>

          <!-- Información de Contacto -->
          <div>
            <h3 class="font-semibold text-gray-900 mb-3">Información de Contacto</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <div>
                <p class="text-gray-600">Nombre</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.contacto.firstname }} {{ selectedFactura()!.contacto.lastname }}</p>
              </div>
              <div>
                <p class="text-gray-600">Email</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.contacto.email }}</p>
              </div>
              <div>
                <p class="text-gray-600">Teléfono</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.contacto.phone }}</p>
              </div>
              <div>
                <p class="text-gray-600">Usuario</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.contacto.username }}</p>
              </div>
            </div>
          </div>

          <!-- Información de Facturación -->
          <div>
            <h3 class="font-semibold text-gray-900 mb-3">Datos de Facturación</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <div>
                <p class="text-gray-600">Nombre/Razón Social</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.informacionfactura.nombre }}</p>
              </div>
              <div>
                <p class="text-gray-600">{{ selectedFactura()!.informacionfactura.tipo_identificacion.descripcion }}</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.informacionfactura.identificacion }}</p>
              </div>
              <div>
                <p class="text-gray-600">Dirección</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.informacionfactura.direccion }}</p>
              </div>
              <div>
                <p class="text-gray-600">Email</p>
                <p class="font-medium text-gray-900">{{ selectedFactura()!.informacionfactura.email }}</p>
              </div>
            </div>
          </div>

          <!-- Items/Tickets -->
          <div>
            <h3 class="font-semibold text-gray-900 mb-3">Tickets</h3>
            <div class="overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Ticket ID</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Precio</th>
                    <th class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Estado</th>
                    <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Precio</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  @for (item of selectedFactura()!.items; track item.ticketid) {
                    <tr>
                      <td class="px-4 py-3 text-sm text-gray-900">{{ item.ticketid }}</td>
                      <td class="px-4 py-3 text-sm text-gray-900">{{ item.precioTipoTicket.nombre_precio }}</td>
                      <td class="px-4 py-3 text-sm text-center">
                        <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                          {{ item.estado }}
                        </span>
                      </td>
                      <td class="px-4 py-3 text-sm text-gray-900 text-right font-medium">${{ item.precioTipoTicket.precio_base.toFixed(2) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>

          <!-- Totales -->
          <div class="bg-gray-50 rounded-lg p-4">
            <h3 class="font-semibold text-gray-900 mb-3">Resumen de Totales</h3>
            <div class="space-y-2 text-sm">
              <div class="flex justify-between">
                <span class="text-gray-600">Tickets</span>
                <span class="font-medium text-gray-900">${{ selectedFactura()!.totales.subtotal_tickets.toFixed(2) }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600">Comisiones</span>
                <span class="font-medium text-gray-900">${{ selectedFactura()!.totales.subtotal_cargo_servicios.toFixed(2) }}</span>
              </div>
              <div class="border-t border-gray-300 my-2"></div>
              <div class="flex justify-between">
                <span class="text-gray-600">Subtotal</span>
                <span class="font-medium text-gray-900">${{ (selectedFactura()!.totales.subtotal_tickets + selectedFactura()!.totales.subtotal_cargo_servicios).toFixed(2) }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600">Impuestos</span>
                <span class="font-medium text-gray-900">${{ (selectedFactura()!.totales.total_iva_tickets + selectedFactura()!.totales.total_iva_cargo_servicios).toFixed(2) }}</span>
              </div>
              @if (selectedFactura()!.totales.total_pasarela_pago) {
                <div class="flex justify-between">
                  <span class="text-gray-600">Comisión pasarela ({{ selectedFactura()!.totales.porcentaje_pasarela_pago }}%)</span>
                  <span class="font-medium text-gray-900">${{ selectedFactura()!.totales.total_pasarela_pago.toFixed(2) }}</span>
                </div>
              }
              <div class="border-t-2 border-gray-900 my-2"></div>
              <div class="flex justify-between text-lg">
                <span class="font-bold text-gray-900">Total</span>
                <span class="font-bold text-[#e8343f]">${{ selectedFactura()!.totales.total_general_factura.toFixed(2) }}</span>
              </div>
            </div>
          </div>

          <!-- Método de Pago -->
          <div>
            <h3 class="font-semibold text-gray-900 mb-3">Método de Pago</h3>
            <div class="bg-gray-50 rounded-lg p-4">
              <p class="text-sm">
                <span class="text-gray-600">Método: </span>
                <span class="font-medium text-gray-900">{{ selectedFactura()!.pasarela_pago.nombre }}</span>
              </p>
              <p class="text-sm mt-1">
                <span class="text-gray-600">Comisión: </span>
                <span class="font-medium text-gray-900">{{ selectedFactura()!.pasarela_pago.comision }}%</span>
              </p>
              @if (selectedFactura()!.pasarela_pago.pasarelaData?.transactionId) {
                <p class="text-sm mt-1">
                  <span class="text-gray-600">ID Transacción: </span>
                  <span class="font-medium text-gray-900">{{ selectedFactura()!.pasarela_pago.pasarelaData.transactionId }}</span>
                </p>
              }
            </div>
          </div>

          <!-- Estado del Email -->
          @if (selectedFactura()!.emailLogs && selectedFactura()!.emailLogs!.length > 0) {
            <div>
              <h3 class="font-semibold text-gray-900 mb-3">Estado del Email</h3>
              @for (emailLog of selectedFactura()!.emailLogs; track emailLog.emaillogid) {
                <div class="bg-gray-50 rounded-lg p-4 space-y-3">
                  <!-- Destinatario y Asunto -->
                  <div>
                    <p class="text-sm">
                      <span class="text-gray-600">Para: </span>
                      <span class="font-medium text-gray-900">{{ emailLog.to_name }} ({{ emailLog.to_email }})</span>
                    </p>
                    <p class="text-sm mt-1">
                      <span class="text-gray-600">Asunto: </span>
                      <span class="font-medium text-gray-900">{{ emailLog.subject }}</span>
                    </p>
                  </div>

                  <!-- Métricas del Email -->
                  <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
                    <div class="bg-white rounded-lg p-3 text-center">
                      <div class="flex items-center justify-center mb-1">
                        @if (emailLog.metrics.delivered) {
                          <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                          </svg>
                        } @else {
                          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                          </svg>
                        }
                      </div>
                      <p class="text-xs font-medium text-gray-900">Entregado</p>
                      @if (emailLog.delivered_at) {
                        <p class="text-xs text-gray-500 mt-1">{{ formatDateTime(emailLog.delivered_at) }}</p>
                      }
                    </div>

                    <div class="bg-white rounded-lg p-3 text-center">
                      <div class="flex items-center justify-center mb-1">
                        @if (emailLog.metrics.opened) {
                          <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                          </svg>
                        } @else {
                          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                          </svg>
                        }
                      </div>
                      <p class="text-xs font-medium text-gray-900">Abierto</p>
                      <p class="text-xs text-gray-500 mt-1">{{ emailLog.open_count }} vez/veces</p>
                      @if (emailLog.opened_at) {
                        <p class="text-xs text-gray-500">{{ formatDateTime(emailLog.opened_at) }}</p>
                      }
                    </div>

                    <div class="bg-white rounded-lg p-3 text-center">
                      <div class="flex items-center justify-center mb-1">
                        @if (emailLog.metrics.clicked) {
                          <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"/>
                          </svg>
                        } @else {
                          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"/>
                          </svg>
                        }
                      </div>
                      <p class="text-xs font-medium text-gray-900">Clics</p>
                      <p class="text-xs text-gray-500 mt-1">{{ emailLog.click_count }} clic(s)</p>
                    </div>

                    <div class="bg-white rounded-lg p-3 text-center">
                      <div class="flex items-center justify-center mb-1">
                        <span [class]="'inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ' + (emailLog.status === 'open' ? 'bg-blue-100 text-blue-800' : emailLog.status === 'delivered' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800')">
                          {{ emailLog.status }}
                        </span>
                      </div>
                      <p class="text-xs font-medium text-gray-900">Estado</p>
                      <p class="text-xs text-gray-500 mt-1">Enviado: {{ formatDateTime(emailLog.sent_at) }}</p>
                    </div>
                  </div>

                  <!-- Tasas de Apertura y Clics -->
                  <div class="grid grid-cols-2 gap-3 pt-2 border-t border-gray-200">
                    <div>
                      <p class="text-xs text-gray-600">Tasa de Apertura</p>
                      <div class="flex items-center gap-2 mt-1">
                        <div class="flex-1 bg-gray-200 rounded-full h-2">
                          <div 
                            class="bg-blue-600 h-2 rounded-full"
                            [style.width.%]="emailLog.metrics.open_rate * 100"
                          ></div>
                        </div>
                        <span class="text-xs font-medium text-gray-900">{{ (emailLog.metrics.open_rate * 100).toFixed(0) }}%</span>
                      </div>
                    </div>
                    <div>
                      <p class="text-xs text-gray-600">Tasa de Clics</p>
                      <div class="flex items-center gap-2 mt-1">
                        <div class="flex-1 bg-gray-200 rounded-full h-2">
                          <div 
                            class="bg-purple-600 h-2 rounded-full"
                            [style.width.%]="emailLog.metrics.click_rate * 100"
                          ></div>
                        </div>
                        <span class="text-xs font-medium text-gray-900">{{ (emailLog.metrics.click_rate * 100).toFixed(0) }}%</span>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <!-- Footer del Modal -->
        <div class="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4">
          @if (resendCooldownRemaining() > 0) {
            <div class="mb-3 bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-2 flex items-center gap-2">
              <svg class="w-4 h-4 text-yellow-600 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span class="text-sm text-yellow-800">
                Puedes reenviar el email en <strong>{{ formatCooldownTime(resendCooldownRemaining()) }}</strong>
              </span>
            </div>
          }
          <div class="flex justify-end gap-3">
            <button
              (click)="closeInvoiceDetail()"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cerrar
            </button>
            <button
              (click)="resendEmail()"
              [disabled]="isResendingEmail() || resendCooldownRemaining() > 0"
              class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              @if (isResendingEmail()) {
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              } @else {
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
              }
              Reenviar Email
            </button>
            <button
              (click)="printInvoice()"
              class="px-4 py-2 text-sm font-medium text-white bg-[#e8343f] rounded-lg hover:bg-[#c42d37] transition-colors flex items-center gap-2"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
              </svg>
              Imprimir
            </button>
          </div>
        </div>
      }
    </div>
  </div>
}

<app-footer />
